import { Badge, Box, Flex, Heading, Text } from "@radix-ui/themes";
import i18next from "i18next";
import { FC } from "react";

const SingleChallengeFormulaFallGuys: FC = (): JSX.Element => {
  return (
    <Box>
      <Heading as="h3" size="2" mb="0">
        {i18next.t("challengeCriteria.fallguys.criteria.positionPoints")}
      </Heading>
      <Text as="p" size="2" color="gray" mb="3">
        {i18next.t("challengeCriteria.fallguys.description.positionPoints")}
      </Text>
      <Heading as="h3" size="2" mb="0">
        {i18next.t("challengeCriteria.fallguys.criteria.medalPoints")}
      </Heading>
      <Text as="div" size="2" color="gray" mb="3">
        <ul style={{ margin: "0", padding: "0 0 0 1rem" }}>
          <li>
            {i18next.t(
              "challengeCriteria.fallguys.description.medalPointsGold"
            )}
          </li>
          <li>
            {i18next.t(
              "challengeCriteria.fallguys.description.medalPointsSilver"
            )}
          </li>
          <li>
            {i18next.t(
              "challengeCriteria.fallguys.description.medalPointsBronze"
            )}
          </li>
        </ul>
      </Text>
      <Heading as="h3" size="2" mb="0">
        {i18next.t("challengeCriteria.fallguys.headline")}
      </Heading>
      <Text size="2" color="gray" mb="2">
        <Flex wrap="wrap" gap="2" mt="2">
          <Badge>
            {i18next.t("challengeCriteria.fallguys.criteria.positionPoints")}
          </Badge>{" "}
          +{" "}
          <Badge>
            50 * {i18next.t("challengeCriteria.fallguys.criteria.medalPoints")}
          </Badge>{" "}
        </Flex>
      </Text>
    </Box>
  );
};

export default SingleChallengeFormulaFallGuys;
